import { createLowlight } from 'lowlight';
import js from 'highlight.js/lib/languages/javascript';
import python from 'highlight.js/lib/languages/python';
import go from 'highlight.js/lib/languages/go';
import java from 'highlight.js/lib/languages/java';
import html from 'highlight.js/lib/languages/xml';
import cpp from 'highlight.js/lib/languages/cpp';
import { useMemo } from 'react';

const useLowlightOptions = () => {
  const lowlightSyntaxHighlighting = useMemo(() => {
    const lowlight = createLowlight();
    lowlight.register('javascript', js);
    lowlight.register('python', python);
    lowlight.register('html', html);
    lowlight.register('java', java);
    lowlight.register('go', go);
    lowlight.register('cpp', cpp);
    return lowlight;
  }, []);

  return lowlightSyntaxHighlighting;
};

export default useLowlightOptions;
